import { render, staticRenderFns } from "./Partecipants.vue?vue&type=template&id=50b0ef1a&"
import script from "./Partecipants.vue?vue&type=script&lang=js&"
export * from "./Partecipants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports